<template>
  <PSPanelCard />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
